import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import styled, {withTheme, css} from 'styled-components';
import Icon from '../icon';
import { defaultTheme } from '../../data/themes';



import { triggerActionEvent } from './common';
import { getPhrase } from '../../data/phrases';

const Wrapper = styled.div`
	position: relative;
	background: ${props => props.theme.inputBackground ?? defaultTheme.inputBackground};
	color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
	border: ${props => props.theme.inputBorder ?? defaultTheme.inputBorder};
	border-radius: ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius};
	outline: ${props => props.theme.inputOutline ?? defaultTheme.inputOutline};
	padding: ${props => props.theme.inputPadding ?? defaultTheme.inputPadding};

	&::selection {
		background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
		color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
	}

	&.readonly {
		background: ${props => props.theme.inputReadOnlyBackground ?? defaultTheme.inputReadOnlyBackground};
		color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
	}

	> .layout {
		position: relative;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};

		input {
			flex-grow: 1;
			border: none;
			outline: none;
			width: 100%;
			font-weight: ${props => props.theme.inputFontWeight ?? defaultTheme.inputFontWeight};
			font-size: ${props => props.theme.inputFontSize ?? defaultTheme.inputFontSize};
			padding: 0px 2px;
			color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
			background: transparent;
			text-align: ${props => props.textAlign};

			&::selection {
				background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
				color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
			}

			&[readonly] {
				color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
			}

			::placeholder {
				color: ${props => props.theme.inputPlaceholderColor ?? defaultTheme.inputPlaceholderColor};
				font-weight: ${props => props.theme.inputPlaceHolderFontWeight ?? defaultTheme.inputPlaceHolderFontWeight};
			}

		}
		> .icon {
			position: relative;
			top: -1px;
			color: ${props => props.theme.lookupInputIconColor ?? props.theme.inputColor ?? defaultTheme.inputColor} !important;
			flex-grow: 0;
			font-size: 12px;
			padding-left: ${props => props.theme.lookupInputIconHorizontalPadding ?? defaultTheme.lookupInputIconHorizontalPadding};
			padding-right: ${props => props.theme.lookupInputIconHorizontalPadding ?? defaultTheme.lookupInputIconHorizontalPadding};
			&.left {
				margin-right: ${props => props.theme.inputLeftIconRightMargin};
			}
			&.right {
				margin-right: ${props => props.theme.inputRightIconLeftMargin};
			}
		}
	}
`;

export default class TextInput2 extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			value: ''
		};
		this.onChange = this.onChange.bind(this);
		this.clear = this.clear.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onRightIconMouseDown = this.onRightIconMouseDown.bind(this);
		this.inputRef = React.createRef();
	}

	onRightIconMouseDown(e) {
		if (this.props.onRightIconMouseDown) {
			this.props.onRightIconMouseDown(e);
		}
	}

	clear() {
		this.doChange(null);
	}


	getValue() {
		if (this.props.changeOnBlur) {
			return this.state.value || '';
		} else {
			return this.props.value || '';
		}
	}

	doChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value);
		}
	}

	inputFilter(value) {
		if (this.props.inputFilter) {
			return this.props.inputFilter(value);
		} else {
			return value;
		}
	}

	onChange(e) {
		if (this.props.changeOnBlur) {
			this.setState({
				value: this.inputFilter(e.target.value)
			});
		} else {
			this.doChange(this.inputFilter(e.target.value));
		}
	}

	isModified() {
		return (this.state.value || '') !== (this.props.value || '');
	}

	onAction(el) {
		if (this.props.changeOnBlur && this.isModified()) {
			this.doChange(this.state.value);
		}
		triggerActionEvent(el);
	}

	onBlur() {
		if (this.props.changeOnBlur) {
			if (this.isModified()) {
				this.doChange(this.state.value);
			}
		}
		if (this.props.onBlur) {
			this.props.onBlur();
		}
	}

/*	componentWillUnmount() {
		console.log('cwu');
		if (this.props.changeOnBlur && this.isModified()) {
			console.log('cwu jooooo - ', this.state.value);
			this.doChange(this.state.value);
		}
	}*/

	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.propsValue === nextProps.value || !nextProps.changeOnBlur) {
			return null;
		}
		return {
			value: nextProps.value,
			propsValue: nextProps.value
		};
	}

	render() {
		const value = this.getValue();
		const hasValue = !!value;
		return (
			<Wrapper
				width={this.props.width}
				data-name={this.props.name}
				data-value={this.props.value}
				textAlign={this.props.textAlign}
				className={
					'component ps-input text2 ' +
					(hasValue ? 'set' : 'empty') +
					(this.props.readOnly ? ' readonly' : '') +
					(this.props.combo ? ' combo' : '') +
					(' ' + (this.props.className || '')) +
					(' ' + (this.state.error || ''))
				}
			>
				<div className="layout">
					{
						this.props.withClearButton && hasValue && !this.props.readOnly && !this.props.mandatory && (
							<Icon
								name="clear"
								className="left"
								active
								onMouseDown={e => {
									e.preventDefault();
									this.clear();
									this.inputRef.current.focus();
								}}
							/>

						)
					}
					<input
						ref={this.inputRef}
						data-name={this.props.name}
						data-autofocusid={this.props.autoFocusId}
						maxLength={this.props.maxLength}
						type={this.props.password ? 'password' : 'text'}
						className={'ps-input text2' + (this.props.readOnly ? ' readonly' : '')}
						placeholder={this.props.placeholder}
						value={value}
						onChange={this.onChange}
						onKeyDown={(e) => {
							if (e.keyCode === 13) {
								this.onAction(e.target);
							}
							if (this.props.onKeyDown) {
								this.props.onKeyDown(e);
							}
						}}
						spellCheck="false"
						autoComplete="new-password"
						name={this.props.name}
						onBlur={this.onBlur}
						readOnly={this.props.readOnly}
						tabIndex={this.props.readOnly ? '-1' : '0'}
					/>
					{
						this.props.rightIcon && (
							<Icon
								name={this.props.rightIcon}
								active
								onMouseDown={this.onRightIconMouseDown}
							/>
						)
					}
				</div>
			</Wrapper>
		);
	}

}
